module.exports = __webpack_public_path__ + "static/media/language.51d5aba5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/language.svg
// module id = 471
// module chunks = 0